import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '../../http-loader-factory';
import { ReferencesComponent } from './references.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PipesModule } from '../../pipes/pipes.module';
import { MatIconModule } from '@angular/material/icon';
import { FileUploadComponent } from '../../../admin/components/file-upload/file-upload.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { UploadFileWithProgressComponent } from '../../../admin/components/upload-file-with-progress/upload-file-with-progress.component';

@NgModule({
  declarations: [ReferencesComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    PipesModule,
    MatIconModule,
    AngularSvgIconModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    FileUploadComponent,
    UploadFileWithProgressComponent,
  ],
})
export class ReferencesModule {}
